import React, { useEffect, useRef, useState } from 'react';
import { useConfiguration } from '../../../hooks/Configuration';
import { useMessageContext } from './MessageContext';

interface IPackerProps {
    children: any
}

let counter = 0

function Packer({ children }: IPackerProps) {
    const configuration = useConfiguration();
    const [packed, setPacked] = useState(false);
    // const [collapsed, setCollapsed] = useState(true);
    const { messageContext, setMessageContext } = useMessageContext();
    const outlerElementRef = useRef<HTMLDivElement | null>(null);
    const innerElementRef = useRef<HTMLDivElement | null>(null);

    const collapsed = !messageContext.messageExpanded;
    const setCollapsed = (tmp: boolean) => setMessageContext({ ...messageContext, messageExpanded: !tmp });

    //kontrola velikosti buňky, pokud je obsahu více než je povoleno, tak se zobrazi robalovátko
    useEffect(() => {
        const outlerElement = outlerElementRef.current;
        const innerElement = innerElementRef.current;

        if (!outlerElement || !innerElement) return;

        // Funkce pro získání velikosti prvku
        const getDimensions = () => {
            // console.log('getDimensions');
            const outlerRect = outlerElement.getBoundingClientRect();
            const innerRect = innerElement.getBoundingClientRect();
            // Zde můžete provádět akce s velikostí
            // console.log('Výška:', outlerRect.height, innerRect.height);
            if (outlerRect.height < innerRect.height) setPacked(true);
        };

        // Ne vždy funguje handleAnimationFrame, takže je tu progresivní časovač, který zjišťuje velikost elementu v intervalech 500, 1000 nebo 3000ms
        const timer = () => {
            getDimensions();

            setTimeout(
                timer,
                counter < 10 ?
                    500 :
                    counter < 30 ?
                        1000 :
                        3000
            )

            counter++;
        }

        // Použijeme requestAnimationFrame k získání velikosti, když je prvek viditelný
        const handleAnimationFrame = () => {
            if (outlerElement && outlerElement.offsetWidth !== 0 && outlerElement.offsetHeight !== 0) {
                getDimensions();
            } else {
                requestAnimationFrame(handleAnimationFrame);
            }
        };

        handleAnimationFrame();
        timer();
    }, []);

    if (!configuration?.features.incommingMessageShowRows) return children;

    const className = ['stx-chat-message-packer'];
    if (!collapsed) className.push('expanded');
    //incommingMessageShowRows
    return (
        <div className={className.join(' ')}>
            <div
                ref={outlerElementRef}
                className='stx-chat-message-packer-content'
                style={{ maxHeight: `${configuration?.features.incommingMessageShowRows * 1.5}em` }}>
                <div ref={innerElementRef}>
                    {children}
                </div>
            </div>
            <button
                className='stx-chat-message-packer-expander cursor-pointer'
                style={{ display: packed ? 'block' : undefined }}
                onClick={() => setCollapsed(!collapsed)}>
                {collapsed ? configuration?.texts.messageExpander : configuration?.texts.messageCollapser}
            </button>
        </div>
    );
}

export default Packer;
